import type React from 'react'

import { getTestProps, type TestIds } from '../../utils/testing.ts'

type FormSectionProps = Readonly<
  TestIds & {
    children: React.ReactNode
  }
>

const FormSection = ({
  children,
  dataTestId,
  dataTrackingId,
}: FormSectionProps) => (
  <section
    className="flex flex-col gap-4 qf-form-section"
    {...getTestProps({ dataTestId, dataTrackingId })}
  >
    {children}
  </section>
)

export { FormSection, type FormSectionProps }
